import React from 'react';
import {ButtonBar, SaveButton, Field, Form} from '../commons/Forms.js';
import {Pane, Part} from '../commons/Panes';
import {connect} from 'react-redux';
import {toastr} from 'react-redux-toastr';
import {modifyApiToken} from '../../redux/user/actions';

import '../../styles/adminPanels.less';

/**
 * Composant de changement de mot de passe
 * @class
 */
@connect(
  state => ({user: state.user}),
  {modifyApiToken}
)
class AccountEdit extends React.Component {

  onSubmit(e) {
    e.preventDefault();

    const oldToken = this.refs.old_token.value();
    const newToken = this.refs.new_token.value();
    const newTokenRepeat = this.refs.new_token_repeat.value();
    let token;
    try {
        sessionStorage.setItem('safariTest', 'ok');
        token = sessionStorage.getItem('token');
    } catch(e) {
        token = window.STORAGE_TOKEN;
    }
    if (oldToken !== token) {
      toastr.error('Le code saisi n\'est pas votre code actuel');
    } else if (newToken !== newTokenRepeat) {
      toastr.error('Les deux codes ne correspondent pas');
    } else {
      this.props.modifyApiToken(this.props.user.infos.id, oldToken, newToken);
      this.props.onEnd();
    }

    return false;
  }

  render() {
    return (
      <Pane title="Réglages">
        <Part title="Code d'accès">
          <Form onSubmit={e => this.onSubmit(e)}>
            <Field ofType="text" label="Code d'accès actuel" ref="old_token"/>
            <Field ofType="text" label="Nouveau code d'accès" ref="new_token"/>
            <Field ofType="text" label="Répétez code d'accès" ref="new_token_repeat"/>
            <ButtonBar>
              <SaveButton/>
            </ButtonBar>
          </Form>
        </Part>
      </Pane>
    )
  }
}

export default AccountEdit;



// WEBPACK FOOTER //
// ./src/components/admin/AccountEdit.js